import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
var FleetSteps = function FleetSteps() {
  var _useTranslation = useTranslation(["web_fleet"]),
    tShort = _useTranslation.tShort;
  var steps = [{
    n: 1,
    title: "step_1_title",
    desc: "step_1_desc",
    from: "#F7D758",
    to: "#FEFAEA",
    num: "text-[#D9A400]"
  }, {
    n: 2,
    title: "step_2_title",
    desc: "step_2_desc",
    from: "#FDB9B9",
    to: "#FEEAEA",
    num: "text-[#E4002B]"
  }, {
    n: 3,
    title: "step_3_title",
    desc: "step_3_desc",
    from: "#E7E7F8",
    to: "#FBFBFB",
    num: "text-[#5B53C6]"
  }, {
    n: 4,
    title: "step_4_title",
    desc: "step_4_desc",
    from: "#00B362",
    to: "#FBFBFB",
    num: "text-[#1BB55C]"
  }];
  return /*#__PURE__*/React.createElement("section", {
    className: "px-4 pt-6 pb-10 md:py-14 bg-white"
  }, /*#__PURE__*/React.createElement("div", {
    className: "md:max-w-[1200px] md:mx-auto"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-2xl md:text-[30px] font-bold text-primary-new text-center mb-8 md:mb-10"
  }, tShort("steps_title", {
    ns: "web_fleet"
  })), /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5"
  }, steps.map(function (step) {
    return /*#__PURE__*/React.createElement("div", {
      key: step.n,
      className: "relative p-3 md:p-5 rounded-[10px] outline outline-1 -outline-offset-1 outline-[#E2E2F6]",
      style: {
        backgroundImage: "linear-gradient(30deg, ".concat(step.from, " 0%, ").concat(step.to, " 100%)")
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "text-black flex items-center justify-center w-8 h-8 ms-auto rounded-full bg-white shadow-[0_2px_8px_rgba(0,0,0,0.08)] text-sm font-bold ".concat(step.num)
    }, step.n), /*#__PURE__*/React.createElement("h3", {
      className: "mt-2 mb-2 text-base md:text-lg font-bold text-[#1B2035]"
    }, tShort(step.title, {
      ns: "web_fleet"
    })), /*#__PURE__*/React.createElement("p", {
      className: "text-sm text-[#00143C] leading-relaxed m-0"
    }, tShort(step.desc, {
      ns: "web_fleet"
    })));
  }))));
};
export default FleetSteps;